import React from 'react'

import Hotkeys from './Hotkeys'

import { OptionList } from './styles'

/**
 *
 */
const FloatingMenu = () => (
  <OptionList>
    <Hotkeys />
  </OptionList>
)

FloatingMenu.propTypes = {}
FloatingMenu.defaultProps = {}

export default FloatingMenu
